module.exports = __webpack_public_path__ + "static/img/04.0a3b4ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/docs/02/04.jpg
// module id = vtaL
// module chunks = 1